import { useLocation } from 'react-router-dom';
import { useAnalytics } from 'src/hooks/analytics/useAnalytics.hook';
import { useIntegrationsContext } from 'src/providers/IntegrationsProvider/Integrations.context';
import { eIntegrationStatus } from 'src/providers/IntegrationsProvider/Integrations.enums';
import { WAPI_EVENTS } from './wapiAnalytics.constants';

type tWapiEventName = (typeof WAPI_EVENTS)[keyof typeof WAPI_EVENTS];
type tWapiContext = 'dashboard' | 'campaigns' | 'chat';

function getBrowser(): string {
  const ua = navigator.userAgent;
  if (ua.includes('Edg/')) return 'Edge';
  if (ua.includes('OPR/') || ua.includes('Opera')) return 'Opera';
  if (ua.includes('Chrome') && !ua.includes('Edg/')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  return 'Other';
}

function deriveWapiContext(pathname: string): tWapiContext {
  if (pathname.includes('/whatsapp-api') || pathname.includes('/dashboard'))
    return 'dashboard';
  if (pathname.includes('/campaign') || pathname.includes('/pipe'))
    return 'campaigns';
  return 'chat';
}

export function useWapiAnalytics() {
  const { trackEvent } = useAnalytics();
  const { whatsappBusinessIntegration } = useIntegrationsContext();
  const location = useLocation();

  const wapiIntegration =
    whatsappBusinessIntegration.state === eIntegrationStatus.CONNECTED;
  const browser = getBrowser();
  const wapiContext = deriveWapiContext(location.pathname);

  function trackWapiEvent(name: tWapiEventName, payload: Record<string, unknown> = {}) {
    trackEvent(name, {
      browser,
      wapi_integration: wapiIntegration,
      wapi_context: wapiContext,
      ...payload,
    });
  }

  return { trackWapiEvent, wapiIntegration, wapiContext, browser };
}
